module.exports = __webpack_public_path__ + "img/university_toronto.5cf795e4.png";